import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  makeStyles,
} from "@material-ui/core";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: 400,
    height: 200,
    padding: 10,
    boxSizing: "border-box",
  },
  clearButton: {
    backgroundColor: theme.red,
    color: theme.white,
    width: 82,
    fontSize: 10,
  },
  cancelButton: {
    width: 82,
    fontSize: 10,
  },
}));

const ClearAllDialog = ({ open, onClose, onClearAll }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      style={{
        width: "100%",
      }}
      classes={{
        paper: classes.dialog,
      }}
    >
      <DialogTitle>
        <Typography align="center" variant="h5">
          {translate("ra.text.addProduct.clearAll")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography align="center" variant="subtitle1">
          {translate("ra.text.addProduct.areYouSure")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          <Button
            className={classes.cancelButton}
            variant="contained"
            onClick={onClose}
            color="secondary"
          >
            {translate("ra.action.cancel")}
          </Button>
          <Button
            className={classes.clearButton}
            variant="contained"
            onClick={() => {
              onClearAll();
              onClose();
            }}
          >
            {translate("ra.text.addProduct.clearAll")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ClearAllDialog;
